import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Logo = () => (
  <div className="flex">
    <StaticImage
      src="../images/logo.png"
      alt="ペアケア"
      width={200}
      placeholder="none"
      className="w-logo lg:w-logo-lg"
    />
  </div>
)

export default Logo
